import { useState } from "react";
import { useParams } from "react-router-dom";

//Bootstrap
import { Card, Col, Button, Row } from "react-bootstrap";

//UI components
import TabCardHeader from "../../../ui/TabCardHeader";
import AccessDenied from "../../../ui/AccessDenied";

//components
import AddClanicoNaProjekt from "./AddClanicoNaProjekt";
import ClaniceNaProjektuCards from "./ClaniceNaProjektuCards";

//API calls
import { useGetClaniceUMNaProjektu } from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";

//Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

//Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const SodelovanjeZnotrajUM = () => {
  const { id } = useParams();
  const [isAdding, setIsAdding] = useState(false);
  const { project } = useProjectDetailsContext();

  const { data: clanice = [], isLoading } = useGetClaniceUMNaProjektu(id);

  const handleAddClanicaNaProjektClick = () => {
    setIsAdding(true);
  };

  if (isLoading) {
    return (
      <Card className="mb-4">
        <TabCardHeader title="Sodelovanje znotraj UM" showEditButton={false} />
        <div className="px-4 pt-4 pb-2">
          <p>Nalaganje sodelujočih članic UM na projektu...</p>
        </div>
      </Card>
    );
  }

  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <Card className="mb-4">
        {/* Header with title and edit button */}
        <TabCardHeader title="Sodelovanje znotraj UM" showEditButton={false} />
        <div className="px-4 pt-4 pb-2">
          <Row>
            <Col md={12}>
              <Row className="align-items-center mb-2">
                <Col md={6}>
                  <h6 className="form-section-heading mb-0">
                    Sodelujoče članice UM
                  </h6>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  {!isAdding && (
                    <RoleGuard
                      moduleKey={MODULES.PROJEKTI}
                      roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
                      vodilnaClanicaProjektaID={project?.clanicaID}
                    >
                      <Button
                        variant="outline-primary border-0"
                        size="sm"
                        onClick={handleAddClanicaNaProjektClick}
                      >
                        Dodaj sodelujočo članico na projekt
                      </Button>
                    </RoleGuard>
                  )}
                </Col>
              </Row>

              {isAdding && (
                <AddClanicoNaProjekt
                  setIsAdding={setIsAdding}
                  projectClanice={clanice}
                />
              )}

              {!isAdding && <ClaniceNaProjektuCards clanice={clanice} />}
            </Col>
          </Row>
        </div>
      </Card>
    </RoleGuard>
  );
};

export default SodelovanjeZnotrajUM;
